export const range = (n: number) =>
  Array.from({ length: n }, (_, key) => key + 1);

export const sample = (arr: Array<any>) =>
  arr[Math.floor(Math.random() * arr.length)];

export function generatePairs(n: number[]): Array<number[]> {
  let pairs = [];
  const k = n.length;

  for (let r = 1; r < k; r++) {
    for (let i = 1; i <= k / 2; i++) {
      if (i == 1) {
        pairs.push([n[1 - 1], n[((k - 1 + r - 1) % (k - 1)) + 1]]);
      } else
        pairs.push([
          n[((r + i - 2) % (k - 1)) + 1],
          n[((k - 1 + r - i) % (k - 1)) + 1],
        ]);
    }
  }

  return pairs;
}

export const chunk = (arr: Array<any>, len: number) => {
  const chunks = [];
  let i = 0;
  const n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }

  return chunks;
};

export const toCamelCase = function (string: string) {
  return string.replace(/\s+(.)/g, function (match, group) {
    return group.toUpperCase();
  });
};

export function camelCaseToTitleCase(str: string) {
  return str
    .replace(/[0-9]{2,}/g, (match) => ` ${match} `)
    .replace(/[^A-Z0-9][A-Z]/g, (match) => `${match[0]} ${match[1]}`)
    .replace(
      /[A-Z][A-Z][^A-Z0-9]/g,
      (match) => `${match[0]} ${match[1]}${match[2]}`
    )
    .replace(/[ ]{2,}/g, (match) => " ")
    .replace(/\s./g, (match) => match.toUpperCase())
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
}

export function generateCode(
  length: number,
  s: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
) {
  return Array(length)
    .join()
    .split(",")
    .map(function () {
      return s.charAt(Math.floor(Math.random() * s.length));
    })
    .join("");
}

export const generateMap = (
  arr: { [key: string]: any }[]
): { [key: string]: any } =>
  arr
    .map((item) => ({ [item.key]: item.value }))
    .reduce((acc, val) => ({ ...acc, ...val }), {});

export const groupByKey = (list: any[], key: string | number) =>
  list.reduce(
    (hash, obj) => ({
      ...hash,
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    }),
    {}
  );

export const isSameDay = function (date: Date, otherDate: Date) {
  return date.toDateString() === otherDate.toDateString();
};

export const isSameMonth = function (date: Date, otherDate: Date) {
  return date.getMonth() === otherDate.getMonth();
};

export const isSameYear = function (date: Date, otherDate: Date) {
  return date.getFullYear() === otherDate.getFullYear();
};

export const parseDateRange = (start: Date, end: Date) => {
  const startMonth = start.toLocaleDateString("en-GB", { month: "long" });
  const endMonth = end.toLocaleDateString("en-GB", { month: "long" });
  // Check if start and end are in the same month
  if (isSameDay(start, end)) {
    return `${start.getDate()} ${startMonth} ${start.getFullYear()}`;
  }
  if (isSameMonth(start, end)) {
    return `${start.getDate()} - ${end.getDate()} ${startMonth} ${start.getFullYear()}`;
  }
  if (isSameYear(start, end)) {
    return `${start.getDate()} ${startMonth} - ${end.getDate()} ${endMonth} ${start.getFullYear()}`;
  }
  return `${start.getDate()} ${startMonth} ${start.getFullYear()} - ${end.getDate()} ${endMonth} ${end.getFullYear()}`;
};

export const countDaysBetween = (startDate: Date, endDate: Date) => {
  let difference = startDate.getTime() - endDate.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
};

export function timeAgo(date: Date): string {
  const now = new Date();
  const elapsed = now.getTime() - date.getTime();
  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (years > 0) {
    return rtf.format(-years, "year");
  } else if (months > 0) {
    return rtf.format(-months, "month");
  } else if (days > 0) {
    return rtf.format(-days, "day");
  } else if (hours > 0) {
    return rtf.format(-hours, "hour");
  } else if (minutes > 0) {
    return rtf.format(-minutes, "minute");
  } else {
    return rtf.format(-seconds, "second");
  }
}

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export function groupByFirstLetter(arr: any[]) {
  return arr.reduce((acc, curr) => {
    const firstLetter = curr[0];
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(curr);
    return acc;
  }, {});
}

export const getLocale = () => {
  if (typeof window !== "undefined") {
    return navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language || "en";
  }
  return "en";
};
